module.exports = __webpack_public_path__ + "img/MB_icono_label_footer_blanco.c7d8148c.png";